/** Same Menus category as Item Tags (view/add/update/delete). */
export const ITEM_PREVIEW_MENUS_CATEGORY_ID = 4
export const WEB_ITEM_PREVIEW_PERMISSION_ID = "web_item_preview_1"
export const MOBILE_ITEM_PREVIEW_PERMISSION_ID = "mobile_item_preview_1"
